import Media from './media.model'
import type { Game as GameType } from '@/types/game.type'

export default class Game implements GameType {
  disabled = false
  room = null
  name = ''
  questions: Question[] = []
  usagesNumber = 0
  setting = {
    lang: 'he',
    collectPhones: false,
    gameType: 'firebase' as 'firebase' | 'remotes' | 'call',
    eventType: null as string | null,
    eventOther: null as string | null,
    participantRange: null as string | null,
    waitingText: '',
    code: null,
    maxParticipants: null,
    titleThroughoutGame: '',
    mainColor: '',
    secondaryColor: '',
    termsLink: '',
    termsText: '',
    showWinnersListAfter: null,
    ansIsNumber: null,
    multiWinners: null,
    gameMedia: new Media(),
    logo: new Media(),
    triviaMedia: new Media(),
    winnersListMedia: new Media(),
    winnersMedia: new Media(),
    sounds: {
      winnersMediaSound: new Media(),
      winnersListMediaSound: new Media(),
      genericMediaSound: new Media(),
      timerMediaSound: new Media(),
      inShowAnsMediaSound: new Media(),
    },
    genericMedia: new Media(),
    participantsMapping: {} as Record<string, string>,
  }
}
